import { IconStyles } from '../types'
import { CancelIconCustom } from './styles'

interface CancelIconProps extends IconStyles {
  onClick?: () => void
  disabled?: boolean
}
export const CancelIcon = ({
  onClick,
  cursor,
  disabled,
  marginBottom,
  marginLeft,
  marginRight,
  marginTop,
  colorIcon
}: CancelIconProps) => {
  return (
    <CancelIconCustom
      disabled={disabled}
      marginTop={marginTop}
      marginBottom={marginBottom}
      marginLeft={marginLeft}
      marginRight={marginRight}
      cursor={cursor}
      onClick={onClick}
      colorIcon={colorIcon}
    />
  )
}
